export const JAM_EVENT_PENDING = 'PENDING';
export const JAM_EVENT_PENDING_APPROVAL = 'PENDING_APPROVAL';
export const JAM_EVENT_UPDATING = 'UPDATING';
export const JAM_EVENT_NOT_STARTED = 'NOT_STARTED';
export const JAM_EVENT_ONGOING = 'ONGOING';
export const JAM_EVENT_ENDED = 'ENDED';
export const JAM_EVENT_CANCELLED = 'CANCELLED';
export const JAM_EVENT_ERROR = 'ERROR';
